import { BidPrice } from 'modules/domain/bid/types'
import { useTranslation } from 'react-i18next'
import { FC, useEffect } from 'react'
import { FormikProps } from 'formik'
import { ShortFormControl } from 'views/styled/common'
import { FormGroup, Input } from '@agro-club/agroclub-shared'
import { USAddBidFields } from 'views/pages/Bid/BidModals/Bid/USModals/types'
import { isDeliveryAddressRequired } from '../../helpers'
import { FormEnumSelect } from 'views/components/form/EnumSelect/FormEnumSelect'

type UsProps = {
  formik: FormikProps<USAddBidFields>
}

export const USATypePriceControl: FC<UsProps> = ({ formik }) => {
  const { t } = useTranslation('bid')
  const needDeliveryData = isDeliveryAddressRequired(formik.values.bid_type, formik.values.price_type)

  useEffect(() => {
    if (needDeliveryData) {
      formik.setFieldValue('owner_delivery_distance', undefined)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [needDeliveryData])

  return (
    <ShortFormControl>
      <FormEnumSelect
        label={t('form.delivery')}
        translationNameSpace="bid:usDeliveryOptions"
        enumType={BidPrice}
        fieldName="price_type"
        formik={formik}
        required
      />

      {needDeliveryData && (
        <FormGroup label={t('form.distance')} error={formik.errors.owner_delivery_distance}>
          <Input
            {...formik.getFieldProps('owner_delivery_distance')}
            invalid={!!formik.errors.owner_delivery_distance}
            type="number"
          />
        </FormGroup>
      )}
    </ShortFormControl>
  )
}
